import { required, equals, password, email } from "./vform-rules";

export const initialAuthFormData = {
    valid: true,
    values: {},
    isSubmitting: false,
    snackbar: null,
    required: required,
    equals: equals,
    password: password,
    email: email,
};
